import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AddCustomer from './pages/customers/AddCustomer';
import ViewCustomers from './pages/customers/ViewCustomers';
import CustomerDetail from './pages/customers/CustomerDetail';
import AddTransaction from './pages/transactions/AddTransaction';
import ViewTransactions from './pages/transactions/ViewTransactions';
import TransactionHistory from './pages/transactions/TransactionHistory';
import CreateInvoice from './pages/invoices/CreateInvoice';
import InvoiceHistory from './pages/invoices/InvoiceHistory';
import InvoiceDetail from './pages/invoices/InvoiceDetail';
import Settings from './pages/Settings';
import LoadingSpinner from './components/LoadingSpinner';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner />;
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

// Public Route Component (redirect if authenticated)
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <LoadingSpinner />;
  }
  
  return !isAuthenticated ? children : <Navigate to="/dashboard" replace />;
};

function AppRoutes() {
  return (
    <Router>
      <Routes>
        <Route 
          path="/login" 
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          } 
        />
        <Route 
          path="/*" 
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  
                  {/* Customer Routes */}
                  <Route path="/customers/add" element={<AddCustomer />} />
                  <Route path="/customers/view" element={<ViewCustomers />} />
                  <Route path="/customers/:id" element={<CustomerDetail />} />
                  
                  {/* Transaction Routes */}
                  <Route path="/transactions/add" element={<AddTransaction />} />
                  <Route path="/transactions/view" element={<ViewTransactions />} />
                  <Route path="/transactions/history" element={<TransactionHistory />} />
                  
                  {/* Invoice Routes */}
                  <Route path="/invoices/create" element={<CreateInvoice />} />
                  <Route path="/invoices/history" element={<InvoiceHistory />} />
                  <Route path="/invoices/:id" element={<InvoiceDetail />} />
                  
                  {/* Settings */}
                  <Route path="/settings" element={<Settings />} />
                  
                  {/* Default redirect */}
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
          <AppRoutes />
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
